// > at({a: {b: {c: [1,2,3]}}}, 'a.b.c.1')
// > 2
export const at = (dict, path) =>
  path
    .split('.')
    .reduce((current, next) => (current && current[next]) || null, dict);

// Return input if array or wrap in array
export const arrayify = a => (Array.isArray(a) ? a : [a]);

export const mapItemCountsByBarcode = items => {
  const map = {};

  items.forEach(product => {
    const keys = Object.keys(product);

    if (keys.includes('amountToRefill')) {
      map[product.barcode] = product.amountToRefill;
    } else {
      map[product.barcode]
        ? map[product.barcode]++
        : (map[product.barcode] = 1);
    }
  });

  return map;
};
